module.exports = __webpack_public_path__ + "img/11087936_L.18cda7d5.png";